import axios from "axios";

//const baseURL = process.env.REACT_APP_BACKEND_URL;
// For Production Environment 
const baseURL = "https://api.makemyhouse.com/";
const mmhBaseURL = "https://makemyhouse.com/";
const mmh_rsform_BaseURL = "https://rsform.makemyhouse.com/"

// For Testing and Development Environment 
// const mmhBaseURL = "https://testing.makemyhouse.com/"
// const baseURL = "https://api-uat.makemyhouse.com/";
// const mmh_rsform_BaseURL = "https://rsform-uat.makemyhouse.com/"

// Images are served straight off the media host, which reads them from R2.
// Going here rather than through api.makemyhouse.com/public/Media/rimage
// skips the redirect hop that host performs to reach the same place.
const mediaBaseURL = "https://media.makemyhouse.com/";

// const mmh_rsform_BaseURL = "http://localhost:3001/"
// const mmh_rsform_BaseURL = "http://localhost:3002/";


let headers = {
  "content-type": "application/json",
  Accept: "application/x-www-form-urlencoded",
  "x-api-key": `${localStorage.getItem("token")}`,
};

const axiosInstance = axios.create({
  baseURL: baseURL,
  headers,
});

const trelloInstance = axios.create({
  baseURL: "https://api.trello.com/1/",
});

export { axiosInstance, baseURL, mmhBaseURL, trelloInstance, mmh_rsform_BaseURL, mediaBaseURL };
